import checkoutItemsHtml from './checkoutitems.component.html';
import checkoutUploadPrintFileModalHtml from './checkoutUploadPrintFile.modal.html';
import './checkoutitems.component.scss';

class CheckoutItemsController {
    constructor($scope, $window, CheckoutService, ModalService, SnackbarService, translateService) {
        'ngInject';

        this.$scope = $scope;
        this.$window = $window;
        this.service = CheckoutService;
        this.ModalService = ModalService;
        this.SnackbarService = SnackbarService;
        this.translate = translateService;

        this.$scope.keyLength = function (obj) {
            return Object.keys(obj).length;
        }
    }

    $onInit() {
        if (!this.service.loaded && !this.service.loading) {
            this.service.load();
        }
    }

    decreaseQuantity(checkoutItem) {
        if (parseInt(checkoutItem.quantity) < 1) return;

        this.changeQuantity(checkoutItem, parseInt(checkoutItem.quantity) - 1);
    }

    increaseQuantity(checkoutItem) {
        this.changeQuantity(checkoutItem, parseInt(checkoutItem.quantity) + 1);
    }

    changeQuantity(checkoutItem, quantity) {
        if (quantity < 1) {
            quantity = 1;
        }

        checkoutItem.quantity = parseInt(quantity);

        this.service.changeQuantity(checkoutItem);
    }

    removeItem(checkoutItem) {
        this.service.removeItem(checkoutItem);
    }

    getProductEditUrl(checkoutItem) {
        return `/configurator/${checkoutItem.slug}`;
    }

    toggleProductPreview(checkoutItem) {
        const previewElement = document.getElementById(`product-preview-${checkoutItem.product_id}`);
        previewElement.classList.toggle('display');
    }

    scrollToFitButtons($event) {
        if (this.$window.innerWidth >= 992) {
            return;
        }

        const buttonsElement = $event.currentTarget.children[0];
        const fixedSummaryElement = angular.element('#checkout-fixed-summary > div')[0];

        const buttonsElementRect = buttonsElement.getBoundingClientRect();
        const fixedSummaryElementRect = fixedSummaryElement.getBoundingClientRect();

        if (buttonsElementRect.top + buttonsElementRect.height + 15 > fixedSummaryElementRect.top) {
            const windowTopY = this.$window.scrollY;
            const windowBottomY = windowTopY + this.$window.innerHeight;
            const targetBottomY = buttonsElementRect.bottom + windowTopY;
            this.$window.scrollTo({
                top: windowTopY - (windowBottomY - targetBottomY) + fixedSummaryElementRect.height + 15,
                left: 0,
                behavior: 'smooth'
            });
        }
    }

    uploadPrintFile(checkoutItem) {
        if (!this.service.userLogged) {
            this.SnackbarService.add('Plik druku może być wgrywany jedynie przez zalogowanych użytkowników.', 'error', true, 3000);

            return;
        }

        if (checkoutItem.type !== 'CartItemPrint') {
            this.SnackbarService.add('Plik druku może być wgrywany jedynie do produktów z konfiguratora druku.', 'error', true, 3000);

            return;
        }

        if (checkoutItem.printFileId !== null) {
            this.SnackbarService.add('Plik druku dla wybranego produktu został już wgrany.', 'error', true, 3000);

            return;
        }

        let _this = this;

        this.ModalService.showModal({
            template: checkoutUploadPrintFileModalHtml,
            controller: class {
                constructor($scope, close) {
                    'ngInject';

                    this.$scope = $scope;
                    this.checkoutItem = checkoutItem;
                    this.closeCallback = close;

                    this.error = false;

                    this.uploadFile = null;
                    this.uploadProgress = 0;
                }

                uploaderProgress(result) {
                    this.uploadProgress = result;
                }

                uploaderComplete(result) {
                    console.log('checkoutitems.component::uploaderComplete()');
                    console.log(result);

                    this.uploadFile = result;
                }

                uploaderError(result) {
                    this.errors.push({
                        message: result,
                        type: 'error'
                    });
                }

                cancel() {
                    this.closeCallback(null);
                }

                save() {
                    this.closeCallback(this.uploadFile);
                }
            },
            controllerAs: '$ctrl',
            preClose: (modal) => {
                modal.element.modal('hide');
            }
        }).then(modal => {
            modal.element.modal({
                backdrop: 'static',
                keyboard: false
            });

            modal.closed.then(response => {
                if (response !== null) {
                    _this.saveUploadedPrintFile(checkoutItem, response);
                }
            });
        });
    }

    saveUploadedPrintFile(checkoutItem, file) {
        if (checkoutItem instanceof Object && file instanceof Object && typeof(file.file_id) !== 'undefined') {
            checkoutItem.printFileId = file.file_id;

            this.service.saveUploadedPrintFile(checkoutItem);
        }
    }
}

let checkoutItemsComponent = {
    bindings: {},
    template: checkoutItemsHtml,
    controller: CheckoutItemsController
}

export default checkoutItemsComponent;
